export default {
  home: 'home',
  'category-root': 'root-category',
  'category-nested': 'category-nested',
  'category-board': 'category-board',
  thread: 'thread'
};
